import { timeStampToDateAndTime } from "../../../functions/dateTime/timeStampToDateAndTime";
import { checkValue } from "../../../functions/checkValue";

export const formatJobcardReportData = (cylindersData) => {
  return cylindersData.map((c) => ({
    "Cylinder Number": c.cylinderNo,
    "Reported At Factory":
      c.gasKg != null ? `${c.gasKg} kg` : formatResultValue(c.resultVal),
    "Reported At Site": checkValue(c.lastDispatchValue),
    "Field Technician": `${c.fieldTechnician.name} (${c.fieldTechnician.mobileNumber})`,
    Supervisor: `${c.supervisor.name} (${c.supervisor.mobileNumber})`,
    "Submitted At": timeStampToDateAndTime(c.submittedAt),
    "Dispatched Site": checkValue(c.lastWorkingStation),
    "Completed By": c.doneBy,
    "Completed At": timeStampToDateAndTime(c.doneAt),
  }));
};

const formatResultValue = (value) => {
  if (value === null || value === undefined) return "";

  const numericValue = Number(value);

  if (value !== "" && !isNaN(numericValue)) {
    return `${value} kg`;
  }

  return value
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};
